# sound middleware for traditional HTML Audio element
sounds  = {}
clones  = {}
timers  = {}
enabled = true

getPath = (name) ->
  name = name.replace("system:", "audio/")
  if name.match /\.[^\.]+$/ then name else "#{name}.mp3"

getAudio = (name, from = sounds) ->
  return null unless name?
  if from[name]
    from[name]
  else if name.match("system:")
    from[name] = new Audio(getPath(name)) if enabled
  else
    from[name] = new Audio(getPath(name))

preload = (path, id, cb = ->) ->
  getAudio(path)
  cb()

play = (name, cb = ->) ->
  sound  = getAudio(name)
  window.clearTimeout timers[name]

  if sound?
    $sound = $(sound).off()

    if not _.isFunction(cb)
      { onProgress, onComplete, cb } = cb
      onTimeUpdate = -> onProgress sound.currentTime / sound.duration
      $sound.on "ended", onComplete
      $sound.on "timeupdate", onTimeUpdate

    sound.currentTime = 0 if sound.currentTime > 0
    sound.play()

  cb { name }

loup = (name, cb = ->) ->
  getClone(name)

  original = getAudio(name)

  if original?
    clone    = getClone(name)
    current  = original
    duration = current.duration * 1000

    return unless duration > 0

    window.clearTimeout timers[name]

    do repeat = ->
      current.currentTime = 0
      current.play()
      current = if current is original then clone else original
      timers[name] = window.setTimeout(repeat, duration)

  cb()

stop = (name, cb = ->) ->
  window.clearTimeout timers[name]
  getAudio(name)?.pause()
  getAudio(name, clones)?.pause()
  cb()

pause = (name) ->
  getAudio(name)?.pause()

resume = (name) ->
  getAudio(name)?.play()

getClone = (name) -> 
  clones[name] ?= new Audio(getPath(name))
  return clones[name]

fadeIn = (name, ms = 2000, increment = 0.05) ->  
  sound   = getAudio(name)
  clone   = getClone(name)
  elapsed = 0

  if sound?
    loup(name)
    clone.volume = sound.volume = 0

    do repeat = ->
      clone.volume = sound.volume = Math.min(sound.volume + increment, 1)

      if sound.volume < 1 and elapsed < ms
        elapsed += ms * increment
        window.setTimeout repeat, ms * increment

fadeOut = (name, ms = 2000, increment = 0.05) ->
  sound   = getAudio(name)
  clone   = getAudio(name, clones)
  elapsed = 0

  if sound?
    do repeat = ->
      clone.volume = sound.volume = Math.max(sound.volume - increment, 0)

      # Safari iOS does not allow you to change the volume of an audio element
      if sound.volume > 0 and elapsed < ms
        elapsed += ms * increment
        window.setTimeout repeat, ms * increment
      else
        stop(name)
        clone.volume = sound.volume = 1

stopAll = ->
  for name, sound of sounds
    sound.pause()

disableSystemSounds = ->
  enabled = false

firstSoundPlayed = (cb) -> cb(null, true)

commands = (next) ->
  {
    preload
    stop
    play
    pause
    resume
    stopAll
    fadeIn
    fadeOut
    disableSystemSounds
    loop:   loup
    stopId: stop
    playId: play
    loopId: loup
    firstSoundPlayed
  }

module.exports = {
  type: "sound"
  commands
}
